import { render, staticRenderFns } from "./viewtraffic.vue?vue&type=template&id=033e0f47&"
import script from "./viewtraffic.vue.js?vue&type=script&lang=js&"
export * from "./viewtraffic.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports